import { gql } from '@apollo/client';

const query = gql`
  query searchSeoRegion($params: JSONObject) {
    searchSeoRegion(params: $params)
  }
`;

module.exports = query;
